import { ApiResponse } from '@shared/models';
import { Division, DivisionDto } from '@app/store/shared/models';

export class Divisions {
    items: Division[];
    total: number;

    constructor(response: ApiResponse<DivisionDto[]>) {
        this.items = response.data.map((dto) => new Division(dto));
        this.total = response.meta?.totalItems ?? 0;
    }
}
